import { render } from "./Locked.vue?vue&type=template&id=60dba974&scoped=true"
import script from "./Locked.vue?vue&type=script&lang=js"
export * from "./Locked.vue?vue&type=script&lang=js"

import "./Locked.vue?vue&type=style&index=0&id=60dba974&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60dba974"]])

export default __exports__